import React from 'react';
import styles from './CTA.module.css';
import Button from '../Shared/Button';

const CTA = ({ onBuyClick }) => {
  const handleOrder = () => {
    if (onBuyClick) {
      onBuyClick();
    } else {
      // Fallback: скролл к pricing
      const pricingSection = document.querySelector('[data-section="pricing"]');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className={styles.cta}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          <span className="gold-text">Ваше будущее начинается сегодня</span>
        </h2>
        <p className={styles.text}>
          Через 21 день вы получите детальный навигатор, который будет вашим спутником весь 2026 год. Начните планирование сегодня - ваш будущий успех зависит от решений, которые вы принимаете сейчас.
        </p>
        <Button onClick={handleOrder} variant="primary" size="large">
          Заказать персональный прогноз за $269
        </Button>
      </div>
    </section>
  );
};

export default CTA;

